import React, { useState } from 'react';

import Button from 'components/common/Button/Button';
import InviteCustomerForm from 'components/applications/ApplicationsPage/InviteCustomerForm/InviteCustomerForm';
import SideBar from 'components/common/SideBar/SideBar';
import ApplicationsTable from 'components/applications/ApplicationsPage/ApplicationsTable/ApplicationsTable';
import ApplicationsFilterPanel from 'components/applications/ApplicationsPage/ApplicationsFilterPanel/ApplicationsFilterPanel';

import styles from './ApplicationsPage.module.scss';

function ApplicationsPage() {
  const [isInviteCustomerOpen, setIsInviteCustomerOpen] = useState(false);

  const handleInviteCustomerOpen = () => {
    setIsInviteCustomerOpen(true);
  };

  const handleInviteCustomerClose = () => {
    setIsInviteCustomerOpen(false);
  };

  return (
    <div className={styles.applicationsPage}>
      <div className={styles.infoContainer}>
        <div className={styles.headerTitle}>Customer Applications</div>
        <div className={styles.inviteButton}>
          <Button className={styles.button} onClick={handleInviteCustomerOpen}>
            Invite Customer To Apply
          </Button>
        </div>
        <SideBar isOpen={isInviteCustomerOpen} onClose={handleInviteCustomerClose} title="Invite Customer to Apply">
          <InviteCustomerForm onClose={handleInviteCustomerClose} />
        </SideBar>
      </div>
      <div className={styles.tableContainer}>
        <ApplicationsFilterPanel />
        <ApplicationsTable />
      </div>
    </div>
  );
}

export default ApplicationsPage;
